// extracted by mini-css-extract-plugin
export default {"container":"F4F9e","phone-block-wrapper":"HzwfG"};